import React from 'react';
import Gear from './Gear';

const GearMechanism: React.FC = () => {
  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        overflow: 'hidden',
        opacity: 0.6,
        zIndex: 1,
      }}
    >
      {/* Large main gear - center */}
      <div
        className="animate-gear-slow"
        style={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <Gear 
          size={180} 
          teeth={24} 
          color="var(--color-primary, #dc2626)"
          innerColor="var(--color-background-alt, #1e1e1e)"
          holeSize={0.4}
        />
      </div>
      
      {/* Top-right gear */}
      <div
        className="animate-gear-reverse-medium"
        style={{
          position: 'absolute',
          right: '15%',
          top: '10%',
        }}
      >
        <Gear 
          size={80} 
          teeth={12} 
          color="var(--color-accent, #8b5cf6)"
          innerColor="var(--color-background-alt, #1e1e1e)"
          holeSize={0.35}
        />
      </div>
      
      {/* Top-left gear */}
      <div
        className="animate-gear-medium"
        style={{
          position: 'absolute',
          left: '10%',
          top: '15%',
        }}
      >
        <Gear 
          size={100} 
          teeth={16} 
          color="var(--color-text-muted, #a8a29e)"
          innerColor="var(--color-background-alt, #1e1e1e)"
          holeSize={0.3}
        />
      </div>
      
      {/* Bottom-left gear */}
      <div
        className="animate-gear-reverse-slow"
        style={{
          position: 'absolute',
          left: '5%',
          bottom: '20%',
        }}
      >
        <Gear 
          size={120} 
          teeth={18} 
          color="var(--color-secondary, #3b82f6)"
          innerColor="var(--color-background-alt, #1e1e1e)"
          holeSize={0.35}
        />
      </div>
      
      {/* Bottom-right gear */}
      <div
        className="animate-gear-fast"
        style={{
          position: 'absolute',
          right: '10%',
          bottom: '15%',
        }}
      >
        <Gear 
          size={70} 
          teeth={10} 
          color="var(--color-primary-light, #ef4444)"
          innerColor="var(--color-background-alt, #1e1e1e)"
          holeSize={0.4}
        />
      </div>
      
      {/* Small decorative gears */}
      <div
        className="animate-gear-reverse-medium"
        style={{
          position: 'absolute',
          right: '25%',
          bottom: '30%',
        }}
      >
        <Gear 
          size={50} 
          teeth={8} 
          color="var(--color-surface, #262626)"
          innerColor="var(--color-background-alt, #1e1e1e)"
          holeSize={0.3}
        />
      </div>
      
      <div
        className="animate-gear-medium"
        style={{
          position: 'absolute',
          left: '25%',
          top: '35%',
        }}
      >
        <Gear 
          size={60} 
          teeth={10} 
          color="var(--color-border, #374151)"
          innerColor="var(--color-background-alt, #1e1e1e)"
          holeSize={0.35}
        />
      </div>
    </div>
  );
};

export default GearMechanism;